import * as React from 'react'

import { InfoIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import TooltipWrapper from '~/client/src/shared/components/TooltipWrapper/TooltipWrapper'

// localization: no text to translate

interface IProps {
  title: string

  isColumn?: boolean
  isBorderHidden?: boolean
  tooltipContent?: string | JSX.Element
}

@observer
export default class WorkflowStepBlock extends React.Component<IProps> {
  public render() {
    const { title, isColumn, isBorderHidden, tooltipContent, children } =
      this.props

    return (
      <div className="row y-start px15 mb8 bg-white">
        <span className="row x-between y-start mw160 py6 pr8 text grey-30 large line-extra-large">
          <span>{title}</span>
          {!!tooltipContent && (
            <TooltipWrapper
              content={tooltipContent}
              className="row no-grow ml8"
            >
              <InfoIcon size={16} className="tw:text-muted-foreground" />
            </TooltipWrapper>
          )}
        </span>
        <div
          className={classList({
            'min-height32': true,
            row: !isColumn,
            col: isColumn,
            'tw:rounded-lg tw:border tw:border-solid tw:border-input tw:px-2.5':
              !isBorderHidden,
          })}
        >
          {children}
        </div>
      </div>
    )
  }
}
